// extracted by mini-css-extract-plugin
export default {"desc":"RoutesFilterHeader_desc__iOTbM"};